import {Squad as SquadComponent} from "../Squad";
import React from "react";

export const Normal = () => {
	return <SquadComponent />
}